function loadView(name) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${name}`);
}
const adminRoutes = [
  {
    path: '/tasklist',
    component: loadView('tasklist/admin'),
    name: '任务列表',
  },
  {
    path: '/incorrectlist',
    component: loadView('incorrectlist'),
    name: '申诉列表',
  },
  {
    path: '/annodoc',
    component: loadView('annodoc'),
    name: '标注文档',
  },
  {
    path: '/salary',
    component: loadView('salary'),
    name: '标注统计',
  },
  {
    path: '/examlist',
    component: loadView('exam/list'),
    name: '测试题集',
  },
  {
    path: '/task/:id',
    component: loadView('task/admin'),
    name: '任务详情',
  },
  {
    path: '/edittask/:id',
    component: loadView('edittask'),
    name: '编辑任务',
  },
  {
    path: '/editexam/:examid',
    component: loadView('exam/editexam'),
    name: '编辑测试题',
  },
  {
    path: '/task/:id/image/annotate',
    component: loadView('imagedetail/annotate'),
    name: '图片标注',
  },
  {
    path: '/task/:id/image/approve',
    component: loadView('imagedetail/approve'),
    name: '图片审核',
  },
  {
    path: '/saapprove/:id',
    component: loadView('imagedetail/saapprove'),
    name: '独立审核',
  },
  {
    path: '/approvetask/:id/edit',
    component: loadView('task/editApprove'),
    name: '编辑审核任务',
  },
  {
    path: '/apprtask/:id/image/:imageid',
    component: loadView('imagedetail/standAlone'),
    name: '独立审核任务图片详情',
  },
  {
    path: '/image/:imageid',
    component: loadView('imagedetail/edit'),
    name: '图片详情',
  },
  {
    path: '/exam/:examtype/:examid/annotate',
    component: loadView('exam/doexam'),
    name: '测试题标注',
  },
  {
    path: '/search',
    component: loadView('search'),
    name: '搜索',
  },
  {
    path: '/examimage',
    component: loadView('exam/ExamImageList'),
    name: '题目图片',
  },
  {
    path: '/model/audit/list',
    component: loadView('task/ModelAudit'),
    name: '模型审核',
  },
  {
    path: '/users',
    component: loadView('users'),
    name: '用户列表',
  },
  {
    path: '/rank',
    component: loadView('rank'),
    name: '排行榜',
  },
  {
    path: '/model/audit/:seq',
    component: loadView('ModelAnno'),
    name: '模型标注',
  },
  {
    path: '/',
    redirect: '/tasklist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const customerRoutes = [
  {
    path: '/tasklist',
    component: loadView('tasklist/customer'),
    name: '任务列表',
  },
  {
    path: '/addtask',
    component: loadView('addtask'),
    name: '新建任务',
  },
  {
    path: '/task/:id',
    component: loadView('task/customer'),
    name: '任务详情',
  },
  {
    path: '/task/:id/image/:imageid',
    component: loadView('imagedetail/show'),
    name: '图片详情',
  },
  {
    path: '/',
    redirect: '/tasklist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const annotatorRoutes = [
  {
    path: '/tasklist',
    component: loadView('tasklist/annotator'),
    name: '任务列表',
  },
  {
    path: '/incorrectlist',
    component: loadView('incorrectlist'),
    name: '申诉列表',
  },
  {
    path: '/annodoc',
    component: loadView('annodoc'),
    name: '标注文档',
  },
  {
    path: '/examlist',
    component: loadView('exam/list'),
    name: '测试题集',
  },
  {
    path: '/match-task/list',
    component: loadView('matchTask/List'),
    name: '匹配标注任务',
  },
  {
    path: '/match-task/annotate/:matchTaskId',
    component: loadView('matchTask/Annotate'),
    name: '匹配标注',
  },
  {
    path: '/salary',
    component: loadView('salary'),
    name: '标注统计',
  },
  {
    path: '/task/:id/image/annotate',
    component: loadView('imagedetail/annotate'),
    name: '图片标注',
  },
  {
    path: '/exam/:examtype/:examid/annotate',
    component: loadView('exam/doexam'),
    name: '测试题标注',
  },
  {
    path: '/',
    redirect: '/tasklist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const approverRoutes = [
  {
    path: '/tasklist',
    component: loadView('tasklist/approver'),
    name: '任务列表',
  },
  {
    path: '/incorrectlist',
    component: loadView('incorrectlist'),
    name: '申诉列表',
  },
  {
    path: '/annodoc',
    component: loadView('annodoc'),
    name: '标注文档',
  },
  {
    path: '/examlist',
    component: loadView('exam/list'),
    name: '测试题集',
  },
  {
    path: '/salary',
    component: loadView('salary'),
    name: '标注统计',
  },
  {
    path: '/task/:id/image/annotate',
    component: loadView('imagedetail/annotate'),
    name: '图片标注',
  },
  {
    path: '/task/:id/image/approve',
    component: loadView('imagedetail/approve'),
    name: '图片审核',
  },
  {
    path: '/saapprove/:id',
    component: loadView('imagedetail/saapprove'),
    name: '独立审核',
  },
  {
    path: '/exam/:examtype/:examid/annotate',
    component: loadView('exam/doexam'),
    name: '测试题标注',
  },
  {
    path: '/rank',
    component: loadView('rank'),
    name: '排行榜',
  },
  {
    path: '/',
    redirect: '/tasklist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const approverTwoRoutes = [
  {
    path: '/tasklist',
    component: loadView('tasklist/approver'),
    name: '任务列表',
  },
  {
    path: '/incorrectlist',
    component: loadView('incorrectlist'),
    name: '申诉列表',
  },
  {
    path: '/annodoc',
    component: loadView('annodoc'),
    name: '标注文档',
  },
  {
    path: '/examlist',
    component: loadView('exam/list'),
    name: '测试题集',
  },
  {
    path: '/salary',
    component: loadView('salary'),
    name: '标注统计',
  },
  {
    path: '/task/:id/image/annotate',
    component: loadView('imagedetail/annotate'),
    name: '图片标注',
  },
  {
    path: '/task/:id/image/approve',
    component: loadView('imagedetail/approve'),
    name: '图片审核',
  },
  {
    path: '/saapprove/:id',
    component: loadView('imagedetail/saapprove'),
    name: '独立审核',
  },
  {
    path: '/exam/:examtype/:examid/annotate',
    component: loadView('exam/doexam'),
    name: '测试题标注',
  },
  {
    path: '/',
    redirect: '/tasklist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const reviewerRoutes = [
  {
    path: '/model/audit/list',
    component: loadView('task/ModelAudit'),
    name: '模型审核',
  },
  {
    path: '/model/audit/:seq',
    component: loadView('ModelAnno'),
    name: '模型标注',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

const defaultRoutes = [
  {
    path: '/annodoc',
    component: loadView('annodoc'),
    name: '标注文档',
  },
  {
    path: '/examlist',
    component: loadView('exam/list'),
    name: '测试题集',
  },
  {
    path: '/task/:id/image/annotate',
    component: loadView('imagedetail/annotate'),
    name: '图片标注',
  },
  {
    path: '/exam/:examtype/:examid/annotate',
    component: loadView('exam/doexam'),
    name: '测试题标注',
  },
  {
    path: '/',
    redirect: '/examlist',
  },
  {
    path: '*',
    component: loadView('404'),
    name: 'Not Found',
  },
];

export const dynamicRoutes = {
  adminRoutes: adminRoutes,
  customerRoutes: customerRoutes,
  annotatorRoutes: annotatorRoutes,
  approverRoutes: approverRoutes,
  approverTwoRoutes: approverTwoRoutes,
  reviewerRoutes,
  defaultRoutes,
};
